import { Directive, ElementRef, inject } from '@angular/core';

@Directive({
  selector: '[appObserve]',
  standalone: true
})
export class ObserveDirective {
  public readonly elementRef: ElementRef<HTMLElement> = inject<ElementRef<HTMLElement>>(ElementRef<HTMLElement>);
}
